import type { BannerApi, BannerUnified } from '@/api/banners/types';
import { getFileUrl } from '@/api/utils/helpers/getFileUrl';

export function unifyBanner(banner: BannerApi): BannerUnified {
  return {
    url: banner.url,
    desktop:
      banner.fileDesktop && banner.typeDesktop
        ? {
            source: getFileUrl(banner.fileDesktop),
            type: banner.typeDesktop,
          }
        : null,
    mobile:
      banner.fileMobile && banner.typeMobile
        ? {
            source: getFileUrl(banner.fileMobile),
            type: banner.typeMobile,
          }
        : null,
  };
}
